/**
 * Default / non-native entry. Web is a no-op.
 */
export async function registerDevicePushToken(_input: {
  userId: string;
  requestPermission?: boolean;
}): Promise<string | null> {
  return null;
}

export function usePushRegistration() {
  // No-op outside native builds.
}
